import React, { useEffect } from "react";

import { useTranslation } from "react-i18next";

import { Caret } from "@routes/IconeSvg";
import { Controller, useFormState, useWatch } from "react-hook-form";

import { Switch } from "@components/tailwindComponents";

import InputTimepickerModal from "../../InputTimepickerModal";
import LunchHoursPicker from "../../LunchHoursPicker";
import { useHourCreateSideEffects } from "../utils/sideEffects";

const WeeklyHoursSectionItem = ({
  day,
  control,
  setValue,
  expandedDayKeys,
  onExpandedDayChange,
  formValidation
}) => {
  const { t } = useTranslation("hours.vacances");
  const baseformName = `weeklyHours.${day.key}.`,
    includeLunchFormName = `${baseformName}isLunchHourShowed`;
  const isLunchHourShowed = useWatch({
    name: includeLunchFormName,
    control,
    defaultValue: false
  });
  const isExpanded = expandedDayKeys.includes(day.key);
  const { errors, submitCount, isSubmitting } = useFormState({ control });
  const invalid = Boolean(errors.weeklyHours?.[day.key]);

  useEffect(() => {
    if (invalid && !isSubmitting) {
      onExpandedDayChange(day.key, true);
    }
  }, [invalid, isSubmitting, submitCount, day.key, onExpandedDayChange]);
  useHourCreateSideEffects({
    setValue,
    control,
    type: "weekly",
    baseName: baseformName
  });

  return (
    <div
      key={day.key}
      className={
        isExpanded ? "arh-rounded arh-bg-[#F4F7F8] arh-mb-1" : "arh-bg-transparent"
      }
    >
      <button
        type="button"
        className="arh-flex arh-w-full arh-items-center arh-justify-between arh-border-none arh-bg-transparent arh-px-3 arh-py-3 arh-text-left"
        onClick={() => onExpandedDayChange(day.key)}
      >
        <span className={`arh-font-poppins arh-text-xs arh-font-medium ${invalid ? "arh-text-invalidColorTextInput" : "arh-text-darkColor"}`}>
          {t(day.label)}
        </span>
        <Caret
          className={`arh-transition-transform ${isExpanded ? "arh-rotate-90" : "arh-rotate-0"}`}
        />
      </button>
      <div className={`arh-px-3 arh-pb-3 ${!isExpanded && "arh-hidden"}`}>
        <div className={`arh-flex arh-items-center arh-justify-between arh-rounded arh-border arh-border-solid ${invalid ? "arh-border-invalidColorTextInput" : "arh-border-greyBorderInput"} arh-bg-white arh-px-3 arh-py-2`}>
          <InputTimepickerModal
            validateOnSubmit
            baseName={baseformName}
            control={control}
            formValidation={formValidation}
            groupInputWidthStyle="arh-w-auto"
          />
        </div>

        <div className="arh-mt-1 arh-flex arh-items-center arh-space-x-3">
          <label className="arh-mb-0 arh-font-poppins arh-text-xs arh-font-medium arh-text-darkColor">
            {t("Inclure une pause-repas")}
          </label>
          <Controller
            control={control}
            name={includeLunchFormName}
            defaultValue={false}
            render={({ field: { value, onChange } }) => (
              <Switch
                checked={Boolean(value)}
                color="arh-bg-orangeColor"
                handleChange={(nextValue) => onChange(Boolean(nextValue))}
              />
            )}
          />
        </div>

        {isLunchHourShowed && (
          <LunchHoursPicker
            baseName={baseformName}
            control={control}
            formValidation={formValidation}
            t={t}
          />
        )}
      </div>
    </div>
  );
};

export default React.memo(WeeklyHoursSectionItem);
